import { render, staticRenderFns } from "./BasePlayer.vue?vue&type=template&id=4127b2aa&scoped=true&"
import script from "./BasePlayer.vue?vue&type=script&lang=js&"
export * from "./BasePlayer.vue?vue&type=script&lang=js&"
import style0 from "./BasePlayer.vue?vue&type=style&index=0&id=4127b2aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4127b2aa",
  null
  
)

export default component.exports